function Playground() {
  return (
    <main className="playground-page">
      <a className="site-link" href="/">
        Back home
      </a>

      <section className="playground-intro">
        <h1>Playground</h1>
        <p>A home for experiments, odd ideas, and little joys.</p>
      </section>

      <section className="renderer-section" aria-label="3D Renderer">
        <div className="renderer-heading">
          <h2>3D Renderer</h2>
          <a className="site-link" href="/playground/3d-renderer/index.html">
            Open full screen
          </a>
        </div>
        <iframe
          className="renderer-frame"
          src="/playground/3d-renderer/index.html"
          title="3D Renderer"
        />
      </section>
    </main>
  );
}

export default Playground;
